<template>
  <div id="channelMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>通道管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{navigationMap[chnlActiveName]}}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-row>
          <el-col :span="22">
            <el-form-item label="客户名称::">
              <el-select v-model="selCustID"
                         filterable
                         clearable
                         placeholder="请选择客户"
                         @change="setPark($event,0)">
                <el-option v-for="item in choiceCusts"
                           :key="item.fCustID"
                           :label="item.unionName"
                           :value="item.fCustID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库名称::">
              <el-select v-model="selfParkID"
                         filterable
                         clearable
                         placeholder="请选择场库">
                <el-option v-for="item in choiceParks"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道编号::">
              <el-input placeholder="请输入通道编号"
                        v-model="fChnlNo">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         icon="el-icon-search"
                         size="small"
                         @click="bindQuery">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2"
                  class="searchRowAdd">
            <el-button type="primary"
                       size="small"
                       @click="addSyncChannel">新增通道</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="chnlActiveName"
               type="card"
               @tab-click="tabClick">
        <el-tab-pane label="通道列表"
                     name="chnlList">
          <el-row>
            <el-table :data="chnlList"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fOpLastTimeName"
                               width="180"
                               label="最后同步时间">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="80"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fChnlNo"
                               width="80"
                               label="通道编号">
              </el-table-column>
              <el-table-column prop="fChnlName"
                               label="通道名称">
              </el-table-column>
              <el-table-column prop="ChnlTypeName"
                               width="100"
                               label="通道类型">
              </el-table-column>
              <el-table-column prop="fLinkman"
                               label="联系人">
              </el-table-column>
              <el-table-column prop="fLinkPhone"
                               label="联系电话">
              </el-table-column>
              <!--<el-table-column-->
              <!--prop="fAddress"-->
              <!--label="通道地址">-->
              <!--</el-table-column>-->
              <el-table-column fixed="right"
                               label="操作"
                               align="center"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewChannel(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editChannel(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteChnlClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synChannel(scope.$index, scope.row,false)">上传</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="待同步"
                     name="synChnlList">
          <el-row>
            <el-table :data="synChnlList"
                      :row-class-name="tableRowClassName"
                      border
                      v-loading="loading"
                      highlight-current-row
                      style="width: 100%"
                      :height="tableHeight"
                      ref="singleTable">
              <el-table-column type="index"
                               width="50"
                               :index="indexMethod"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               width="80"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               width="200"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkNo"
                               width="80"
                               label="场库编号">
              </el-table-column>
              <el-table-column prop="fParkName"
                               width="200"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fChnlNo"
                               width="80"
                               label="通道编号">
              </el-table-column>
              <el-table-column prop="fChnlName"
                               label="通道名称">
              </el-table-column>
              <el-table-column prop="ChnlTypeName"
                               width="100"
                               label="通道类型">
              </el-table-column>
              <el-table-column prop="fSyncRemark"
                               label="同步说明">
              </el-table-column>
              <!--<el-table-column-->
              <!--prop="fLinkman"-->
              <!--label="联系人">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
              <!--prop="fLinkPhone"-->
              <!--label="联系电话">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
              <!--prop="fAddress"-->
              <!--label="通道地址">-->
              <!--</el-table-column>-->
              <el-table-column fixed="right"
                               label="操作"
                               align="center"
                               width="300">
                <template slot-scope="scope">
                  <el-button @click="viewChannel(scope.row)"
                             type="success"
                             size="mini">查看</el-button>
                  <el-button size="mini"
                             type="warning"
                             v-if="is_edit"
                             @click="editChannel(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini"
                             type="danger"
                             v-if="is_del"
                             @click="deleteChnlClient(scope.$index, scope.row)">删除</el-button>
                  <el-button size="mini"
                             type="info"
                             v-if="is_syn"
                             @click="synChannel(scope.$index, scope.row,true)">下发</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination background
                         @size-change="handleSizeChange"
                         :current-page.sync="pageNo"
                         @current-change="handlePage"
                         :page-size="pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="total"
                         v-if="total>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div class="myChnlEditOrDetail">
      <el-dialog width="30%"
                 title="设置语音播报参数"
                 class="voiceDialog"
                 v-dialogDrag
                 :visible.sync="voiceParamSetting"
                 top="15vh"
                 left="0vh">
        <el-row>
          <el-form :inline="true"
                   label-width="180px">
            <el-row style="margin-top:10px;">
              <el-col :span="24">
                <el-form-item label="通讯设备访问用户::">
                  <el-input v-model="chnlDeviceInfoObject.p21170"
                            :disabled="!curRowInfo.isEdit"
                            class="myChnlInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="通讯设备访问密码::">
                  <el-input v-model="chnlDeviceInfoObject.p21180"
                            :disabled="!curRowInfo.isEdit"
                            class="myChnlInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="播报语音（需万能语音卡)::">
                  <el-input v-model="chnlDeviceInfoObject.p21181"
                            :disabled="!curRowInfo.isEdit"
                            class="myChnlInput"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24"
                      style="color:red;
                      text-align:center;">语音播报要区分月车和临时车可用 @车辆类型 变量</el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="正常音量::"
                              label-width="80px">
                  <el-select v-model="chnlDeviceInfoObject.p21160"
                             :disabled="!curRowInfo.isEdit"
                             placeholder="选择音量"
                             class="myChnlInput"
                             style="width:200px">
                    <el-option v-for="item in volList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="13">
                <el-form-item label="夜间时段::"
                              label-width="80px">
                  <el-select v-model="chnlDeviceInfoObject.p21163"
                             :disabled="!curRowInfo.isEdit"
                             class="myChnlInput"
                             style="width:100px">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="chnlDeviceInfoObject.p21164"
                             :disabled="!curRowInfo.isEdit"
                             class="myChnlInput"
                             style="width:100px">
                    <el-option v-for="item in time"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="音量::"
                              label-width="60px">
                  <el-select v-model="chnlDeviceInfoObject.p21165"
                             :disabled="!curRowInfo.isEdit"
                             placeholder="选择音量"
                             class="myChnlInput"
                             style="width:150px">
                    <el-option v-for="item in volList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="voiceParamSetting = false"
                     v-if="curRowInfo.isEdit">保存</el-button>
          <el-button @click="voiceParamSetting = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog width="30%"
                 title="显示屏参数说明"
                 v-dialogDrag
                 :visible.sync="ledParamUI"
                 top="25vh"
                 left="0vh"
                 class="ledDialog">
        <el-row>
          <el-col :span="24"
                  style="background-color: #f2dede;padding-left: 15px;padding-right: 15px">
            勾选固定显示后，此行信息不会发生变动 固定信息为无车情况下的显示内容， 过车显示为车辆通过时触发的屏显
          </el-col>
        </el-row>
        <el-row>
          <el-form>
            <el-row>
              <el-col :span="5"
                      class="el-form-item__label myChnlLableClass">请选择参数::</el-col>
              <el-col :span="19">
                <el-select v-model="ledParamSelect"
                           class="myChnlInput">
                  <el-option value="1"
                             label="@余位"></el-option>
                  <el-option value="2"
                             label="@进场时间"></el-option>
                  <el-option value="3"
                             label="@出场时间"></el-option>
                  <el-option value="4"
                             label="@停留时间"></el-option>
                  <el-option value="5"
                             label="@收费金额"></el-option>
                  <el-option value="6"
                             label="@日期星期时间"></el-option>
                  <el-option value="7"
                             label="@车牌"></el-option>
                  <el-option value="8"
                             label="@消息"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"
                      class="el-form-item__label myChnlLableClass">参数说明::</el-col>
              <el-col :span="15">
                <el-input type="textarea"
                          v-html="ledParamDes"
                          class="el-textarea__inner"></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5"
                      class="el-form-item__label myChnlLableClass">范例::</el-col>
              <el-col :span="18">
                <el-input type="textarea"
                          v-html="ledParamExample"
                          class="el-textarea__inner"></el-input>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="ledParamUI = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog width="50%"
                 class="screenDialog"
                 title="设置LED屏基本信息"
                 v-dialogDrag
                 :visible.sync="innerVisible"
                 top="15vh"
                 left="0vh">
        <el-form>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">通讯设备访问用户::</el-col>
            <el-col :span="7">
              <el-input v-model="chnlDeviceInfoObject.txtDevUser"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">通讯设备访问密码::</el-col>
            <el-col :span="7">
              <el-input v-model="chnlDeviceInfoObject.txtDevPwd"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">LED屏幕行::</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboRow"
                         :disabled="!curRowInfo.isEdit"
                         placeholder="请选择行"
                         class="myChnlInput">
                <el-option v-for="item in rowCol"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1"
                    align="center"
                    style="margin-top: 5px">列</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboCol"
                         placeholder="请选择列"
                         :disabled="!curRowInfo.isEdit"
                         class="myChnlInput">
                <el-option v-for="item in rowCol"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">&nbsp;</el-col>
            <el-col :span="3"
                    align="center"
                    style="margin-top: 5px">固定信息</el-col>
            <el-col :span="1"
                    align="center"
                    style="margin-top: 5px">&nbsp;</el-col>
            <el-col :span="3"
                    align="center"
                    style="margin-top: 5px">过车信息</el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="3"
                    align="center"
                    style="margin-top: 5px"><a href="javascript:void(0);"
                 v-on:click="ledParamUI=true"
                 style="text-decoration: none">参数说明</a></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第一行显示内容::</el-col>
            <el-col :span="3">
              <el-input v-model="chnlDeviceInfoObject.tbCnt1"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    align="center">
              <el-input v-model="chnlDeviceInfoObject.tbCarPassMessage1"
                        :disabled="!curRowInfo.isEdit || chnlDeviceInfoObject.chkFixed1"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="2"
                    align="center"
                    style="margin-top: 5px">颜色::</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboClr1"
                         placeholder="请选择"
                         :disabled="!curRowInfo.isEdit"
                         class="myChnlInput">
                <el-option v-for="item in ledColors"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    style="margin-top: 4px">
              <el-checkbox v-model="chnlDeviceInfoObject.chkFixed1"
                           :disabled="!curRowInfo.isEdit">固定显示</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第二行显示内容::</el-col>
            <el-col :span="3">
              <el-input v-model="chnlDeviceInfoObject.tbCnt2"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    align="center">
              <el-input v-model="chnlDeviceInfoObject.tbCarPassMessage2"
                        :disabled="!curRowInfo.isEdit || chnlDeviceInfoObject.chkFixed2"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="2"
                    align="center"
                    style="margin-top: 5px">颜色::</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboClr2"
                         placeholder="请选择"
                         :disabled="!curRowInfo.isEdit"
                         class="myChnlInput">
                <el-option v-for="item in ledColors"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    style="margin-top: 4px">
              <el-checkbox v-model="chnlDeviceInfoObject.chkFixed2"
                           :disabled="!curRowInfo.isEdit">固定显示</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第三行显示内容::</el-col>
            <el-col :span="3">
              <el-input v-model="chnlDeviceInfoObject.tbCnt3"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    align="center">
              <el-input v-model="chnlDeviceInfoObject.tbCarPassMessage3"
                        :disabled="!curRowInfo.isEdit || chnlDeviceInfoObject.chkFixed3"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="2"
                    align="center"
                    style="margin-top: 5px">颜色::</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboClr3"
                         placeholder="请选择"
                         :disabled="!curRowInfo.isEdit"
                         class="myChnlInput">
                <el-option v-for="item in ledColors"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    style="margin-top: 4px">
              <el-checkbox v-model="chnlDeviceInfoObject.chkFixed3"
                           :disabled="!curRowInfo.isEdit">固定显示</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第四行显示内容::</el-col>
            <el-col :span="3">
              <el-input v-model="chnlDeviceInfoObject.tbCnt4"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    align="center">
              <el-input v-model="chnlDeviceInfoObject.tbCarPassMessage4"
                        :disabled="!curRowInfo.isEdit || chnlDeviceInfoObject.chkFixed4"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="2"
                    align="center"
                    style="margin-top: 5px">颜色::</el-col>
            <el-col :span="3">
              <el-select v-model="chnlDeviceInfoObject.cboClr4"
                         placeholder="请选择"
                         :disabled="!curRowInfo.isEdit"
                         class="myChnlInput">
                <el-option v-for="item in ledColors"
                           :key="item"
                           :label="item"
                           :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="3"
                    style="margin-top: 4px">
              <el-checkbox v-model="chnlDeviceInfoObject.chkFixed4"
                           :disabled="!curRowInfo.isEdit">固定显示</el-checkbox>
            </el-col>
          </el-row>
          <el-row v-if="isShowCodeUrl">
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">{{chnlDeviceInfoObject.carCodeTip}}</el-col>
            <el-col :span="12">
              <el-input v-model="chnlDeviceInfoObject.carCode"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24"
                    align="center"
                    style="margin-top: 5px;color:red;">未设置显示内容和显示颜色表示该行不使用</el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="ledSettingSave('led')"
                     v-if="curRowInfo.isEdit">保存</el-button>
          <el-button @click="innerVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog width="50%"
                 title="设置LCD屏过车信息"
                 class="screenDialog"
                 v-dialogDrag
                 :visible.sync="lcdVisible"
                 top="15vh"
                 left="0vh">
        <el-form>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">&nbsp;</el-col>
            <el-col :span="3"
                    align="center"
                    style="margin-top: 5px"><a href="javascript:void(0);"
                 v-on:click="ledParamUI=true"
                 style="text-decoration: none">参数说明</a></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第一行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content1"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第四行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content4"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第二行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content2"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第五行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content5"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第三行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content3"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">第六行显示内容::</el-col>
            <el-col :span="6">
              <el-input v-model="chnlDeviceInfoObject.content6"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5"
                    class="el-form-item__label myChnlLableClass">直付二维码::</el-col>
            <el-col :span="11">
              <el-input v-model="chnlDeviceInfoObject.noCarCode"
                        :disabled="!curRowInfo.isEdit"
                        class="myChnlInput"></el-input>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="ledSettingSave('lcd')"
                     v-if="curRowInfo.isEdit">保存</el-button>
          <el-button @click="lcdVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="detailTitle"
                 v-dialogDrag
                 :visible.sync="chnlEditOrDetailVisible"
                 class="channelDialog"
                 top="7vh"
                 left="0vh"
                 width="55%">
        <el-row style="margin-top:5px;">
          <el-col :span="4"
                  class="el-form-item__label myParkLableClass">客户名称::</el-col>
          <el-col :span="5">
            <el-select v-model="curRowInfo.fCustID"
                       filterable
                       placeholder="请选择客户"
                       :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                       class="myChnlInput"
                       style="width: 100%"
                       @change="setPark($event,1)">
              <el-option v-for="item in choiceCusts"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2"
                  class="el-form-item__label myChnlLableClass">场库名称::</el-col>
          <el-col :span="5">
            <el-select v-model="curRowInfo.fParkID"
                       filterable
                       placeholder="请选择场库"
                       :disabled="!curRowInfo.isEdit||curRowInfo.op=='edit'"
                       class="myChnlInput"
                       style="width: 100%">
              <el-option v-for="item in parks"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4"
                  class="el-form-item__label myChnlLableClass">通道类型::</el-col>
          <el-col :span="5">
            <el-select v-model="curRowInfo.fChnlTypeID"
                       filterable
                       placeholder="请选择通道类型"
                       :disabled="!curRowInfo.isEdit"
                       @change="changeChnlType"
                       class="myParkInput"
                       style="width: 100%">
              <el-option v-for="item in chnlTypeList"
                         :key="item.value"
                         :label="item.text"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2"
                  class="el-form-item__label myChnlLableClass">通道编号::</el-col>
          <el-col :span="5">
            <el-input v-model="curRowInfo.fChnlNo"
                      :disabled="!curRowInfo.isEdit"
                      class="myChnlInput"></el-input>
          </el-col>
          <el-col :span="6"
                  style="color:red;margin-top:6px;margin-left:6px;">通道编号只允许输入字母和数字</el-col>
        </el-row>
        <el-row>
          <el-col :span="4"
                  class="el-form-item__label myChnlLableClass">通道名称::</el-col>
          <el-col :span="5">
            <el-input v-model="curRowInfo.fChnlName"
                      :disabled="!curRowInfo.isEdit"
                      class="myChnlInput"></el-input>
          </el-col>
          <el-col :span="2"
                  class="el-form-item__label myChnlLableClass">联系人::</el-col>
          <el-col :span="5">
            <el-input v-model="curRowInfo.fLinkman"
                      :disabled="!curRowInfo.isEdit"
                      class="myChnlInput"></el-input>
          </el-col>
          <el-col :span="2"
                  class="el-form-item__label myChnlLableClass">联系电话::</el-col>
          <el-col :span="5">
            <el-input v-model="curRowInfo.fLinkPhone"
                      :disabled="!curRowInfo.isEdit"
                      class="myChnlInput"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4"
                  class="el-form-item__label myChnlLableClass">通道地址::</el-col>
          <el-col :span="12">
            <el-input v-model="curRowInfo.fAddress"
                      :disabled="!curRowInfo.isEdit"
                      class="myChnlInput"></el-input>
          </el-col>
        </el-row>
        <el-tabs v-model="editOrDetail"
                 type="card">
          <!-- style="height: 436px" -->
          <el-tab-pane label="通行设置"
                       name="chnlInfo">
            <el-form :model="curRowInfo"
                     label-width="20px"
                     style="margin-top:10px;">
              <el-row style="border:1px solid #ccc;padding:5px;">
                <el-row>
                  <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20040"
                                 :disabled="!curRowInfo.isEdit">本通道允许月卡车通行</el-checkbox>
                  </el-form-item>
                  </el-col>
                  <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20040">
                  <el-form-item label="进场方式::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20041"
                               filterable
                               placeholder="请选择进场方式"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in monCarInTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  </el-col>
                  <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20040&&chnlPassInfoObject.p20041!='1'">
                  <el-form-item label="等待延时（秒）::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20042"
                               filterable
                               placeholder="请选择等待延时"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in monCarWaitDelayList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  </el-col>
                  <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20040&&chnlPassInfoObject.p20041!='1'">
                  <el-form-item label="超时处理::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20043"
                               filterable
                               placeholder="请选择超时处理"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in monCarTimeOutTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="!is_out&&chnlPassInfoObject.p20040&&chnlPassInfoObject.p20041!='1'">
                 <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20045"
                                 :disabled="!curRowInfo.isEdit">包含以临时车身份进场的月卡车</el-checkbox>
                  </el-form-item>
                </el-col>
                 <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20044"
                                 :disabled="!curRowInfo.isEdit">包含VIP类型月卡车</el-checkbox>
                  </el-form-item>
                </el-col>
                </el-row>
                 <el-row  v-if="!is_out&&chnlPassInfoObject.p20040&&chnlPassInfoObject.p20041!='1'">
                 <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p21374"
                                 :disabled="!curRowInfo.isEdit">月卡车启用防疫检查</el-checkbox>
                  </el-form-item>
                 </el-col>
                    <el-col :span="6" v-if="chnlPassInfoObject.p21374">
                     <el-form-item label="防疫检查类型::" label-width="120px">
                       <el-select v-model="chnlPassInfoObject.p21375"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                       <el-option v-for="item in monHSTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              </el-row>
              <el-row style="border:1px solid #ccc;padding:5px;">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20030"
                                 :disabled="!curRowInfo.isEdit">本通道允许临时车通行</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20030&&chnlPassInfoObject.p20030">
                  <el-form-item label="进场方式::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20031"
                               filterable
                               placeholder="请选择进场方式"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in tmpCarInTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20030&&chnlPassInfoObject.p20031!='1'">
                  <el-form-item label="等待延时（秒）::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20032"
                               filterable
                               placeholder="请选择等待延时"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in tmpCarWaitDelayList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="!is_out&&chnlPassInfoObject.p20030&&chnlPassInfoObject.p20031!='1'">
                  <el-form-item label="超时处理::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20033"
                               filterable
                               placeholder="请选择超时处理"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in tmpCarTimeOutTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!is_out&&chnlPassInfoObject.p20030">
                <el-col :span="6" v-if="chnlPassInfoObject.p20031!='1'">
                   <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p21376"
                                 :disabled="!curRowInfo.isEdit">临时车启用防疫检查</el-checkbox>
                  </el-form-item>
                </el-col>
                      <el-col :span="6"
                        v-if="chnlPassInfoObject.p20031!='1'&&chnlPassInfoObject.p21376">
                  <el-form-item label="防疫检查类型::" label-width="120px">
                       <el-select v-model="chnlPassInfoObject.p21377"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in tempHSTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                  <el-col :span="10"
                        >
                  <el-form-item label="非本场库月卡车进场方式::" label-width="180px">
                       <el-select v-model="chnlPassInfoObject.p20100"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in othCardInTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20020"
                                 :disabled="!curRowInfo.isEdit">本通道是同进同出通道</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="chnlPassInfoObject.p20020==true">
                  <el-form-item label="等待延时（秒）::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p21270"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择等待延时（秒）">
                      <el-option v-for="item in delayMgrList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20060"
                                 :disabled="!curRowInfo.isEdit">本通道是两场库共用通道</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="this.chnl_ShareChnlInPark">
                  <el-form-item label="进场场库::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p20080"
                               filterable
                               placeholder="请选择进场场库"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in parks"
                                 :key="item.fParkID"
                                 :label="item.fParkName"
                                 :value="item.fParkID">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="!is_out">
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20081"
                                 :disabled="!curRowInfo.isEdit">车满时本通道开启排队进场模式</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="排队时间::"
                                label-width="120px">
                    <el-input v-model="chnlPassInfoObject.p20082"
                              :disabled="!curRowInfo.isEdit"
                              style="width:150px"></el-input>
                    <label>分钟（值为0时表示是一直等待）</label>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6"
                        v-if="is_out">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20070"
                                 :disabled="!curRowInfo.isEdit">本通道为离场通道</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="chnlPassInfoObject.p20070">
                  <el-form-item label="出场方式::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p21290"
                               filterable
                               placeholder="请选择出场方式"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in closeTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6"
                        v-if="chnlPassInfoObject.p20070&&chnlPassInfoObject.p21290!='0'&&chnlPassInfoObject.p21290.trim().length>0">
                  <el-form-item label="等待延时（秒）::"
                                label-width="120px">
                    <el-select v-model="chnlPassInfoObject.p21280"
                               filterable
                               placeholder="请选择等待延时（秒）"
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in closeTimeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12"
                        v-if="is_out">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p21300"
                                 :disabled="!curRowInfo.isEdit">已有收费界面时，允许自动切换（岗亭无人模式）</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12"
                        v-if="is_out">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20083"
                                 :disabled="!curRowInfo.isEdit">本通道开启防跟车处理（只针对出场类型通道，需硬件支持）</el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
            <el-row>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p20090"
                                 :disabled="!curRowInfo.isEdit">通道限时开放</el-checkbox>
                  </el-form-item>
                </el-col>
                   <el-col :span="6" v-if="chnlPassInfoObject.p20090">
                  <el-form-item label="起始时间::"   label-width="90px">
                    <el-select v-model="chnlPassInfoObject.p20091"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="起始时间">
                      <el-option v-for="item in timeToComboBoxList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                   <el-col :span="6" v-if="chnlPassInfoObject.p20090">
                  <el-form-item label="结束时间::"  label-width="90px">
                    <el-select v-model="chnlPassInfoObject.p20092"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="结束时间">
                      <el-option v-for="item in timeToComboBoxList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                  <el-form-item label="">
                    <el-checkbox v-model="chnlPassInfoObject.p21380"
                                 :disabled="!curRowInfo.isEdit">短期触发过滤</el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="chnlPassInfoObject.p21380">
                  <el-form-item label="最小识别间隔::"
                                label-width="120px">
                    <el-input v-model="chnlPassInfoObject.p21381"
                              :disabled="!curRowInfo.isEdit"
                              style="width:150px"></el-input>
                    <label>秒（可设置值为1-5）</label>
                  </el-form-item>
                </el-col>
            </el-row>
            </el-form>
          </el-tab-pane>
          <!--<el-tab-pane label="通行设置" name="chnlEditPassInfo" style="height: 436px">-->
          <!--<el-form :model="chnlPassInfoObject">-->
          <!--</el-form>-->
          <!--</el-tab-pane>-->
          <el-tab-pane label="通道设备"
                       name="chnlEditDeviceInfo"
                       :model="chnlDeviceInfoObject">
            <fieldset>
              <legend style="padding-top: 5px">摄像机设置</legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">摄像机型号::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21010"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in camList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">摄像机IP::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21020"
                              :disabled="chnlDeviceInfoObject.p21010 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">用户::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21021"
                              :disabled="chnlDeviceInfoObject.p21010 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">密码::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21022"
                              :disabled="chnlDeviceInfoObject.p21010 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">主相机序列号::</el-col>
                  <el-col :span="5">
                    <el-input v-model="chnlDeviceInfoObject.p21023"
                              :disabled="!curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">从相机序列号::</el-col>
                  <el-col :span="5">
                    <el-input v-model="chnlDeviceInfoObject.p21043"
                              :disabled="!curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label=" "
                                  label-width="50px">
                      <el-checkbox v-model="chnlDeviceInfoObject.p21024"
                                   :disabled="!curRowInfo.isEdit">不使用视频流</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <!-- <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">遥控器确认开闸IO::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21025"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in crtIoList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col> -->
                  <el-col :span="3">
                    <el-form-item label=" "
                                  label-width="50px">
                      <el-checkbox v-model="chnlDeviceInfoObject.p21026"
                                   :disabled="!curRowInfo.isEdit">遥控器开闸程序发开闸指令</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>显示屏设置</legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">通讯设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21082"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in ledMainList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">主板型号::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21080"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput"
                               id="input_21080">
                      <el-option v-for="item in ledMainTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">通讯IP::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21081"
                              :disabled="chnlDeviceInfoObject.p21080 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="3">
                    <a href="javascript:void(0);"
                       v-on:click="ledSetting(chnlDeviceInfoObject.p21080,1)"
                       :style="led1">显示屏设置</a>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">通讯设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21092"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in ledSubList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">从主板型号::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21090"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput"
                               id="input_21090">
                      <el-option v-for="item in ledSubTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">通讯IP::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21091"
                              :disabled="chnlDeviceInfoObject.p21090 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="3">
                    <a href="javascript:void(0);"
                       v-on:click="ledSetting(chnlDeviceInfoObject.p21090,2)"
                       :style="led2">显示屏设置</a>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">通讯设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21102"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in ledFullList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">满位屏主板型号::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21100"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput"
                               id="input_21100">
                      <el-option v-for="item in ledFullTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">通讯IP::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21101"
                              :disabled="chnlDeviceInfoObject.p21100 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="3">
                    <a href="javascript:void(0);"
                       v-on:click="ledSetting(chnlDeviceInfoObject.p21100,3)"
                       :style="led3">显示屏设置</a>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>语音设置</legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">语音通讯设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21130"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in voiceList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">语音屏主板型号::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21140"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in voiceTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">通讯IP::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21150"
                              :disabled="!curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="3">
                    <a href="javascript:void(0);"
                       v-on:click="voiceSetting()"
                       :style="led4">语音设置</a>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend>道闸控制设备</legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">道闸控制设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21110"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in chnlGateList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">主板IP地址::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21120"
                              :disabled="chnlDeviceInfoObject.p21110 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">序列号::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21121"
                              :disabled="chnlDeviceInfoObject.p21110 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">遥控器开闸检测设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21190"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in remoteOpenGateList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">主板IP地址::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21200"
                              :disabled="chnlDeviceInfoObject.p21190 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">序列号::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21210"
                              :disabled="chnlDeviceInfoObject.p21190 === '0' || !curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">处理方式::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21220"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in rmtCtlOpenTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend> 通道支付B2C设备 </legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">扫码设备通讯端口::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21230"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择通讯端口"
                               class="myChnlInput">
                      <el-option v-for="item in comPortList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">LED/语音设备::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21240"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择语音设备"
                               class="myChnlInput"
                               id="input_21240">
                      <el-option v-for="item in devList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">端口::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21250"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择端口"
                               class="myChnlInput">
                      <el-option v-for="item in comPortList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2"
                          class="el-form-item__label myChnlLableClass">音量::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21260"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择音量"
                               class="myChnlInput">
                      <el-option v-for="item in volList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3">
                    <a href="javascript:void(0);"
                       v-on:click="ledSetting(chnlDeviceInfoObject.p21240,4)"
                       :style="led5">LED设置</a>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend> ETC设备 </legend>
              <el-form>
                <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">设备名称::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21310"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               placeholder="请选择ETC设备"
                               class="myChnlInput">
                      <el-option v-for="item in etcTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="3"
                          class="el-form-item__label myChnlLableClass">IP地址::</el-col>
                  <el-col :span="3">
                    <el-input v-model="chnlDeviceInfoObject.p21320"
                              :disabled="!curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">使用方式::</el-col>
                  <el-col :span="3">
                    <el-select v-model="chnlDeviceInfoObject.p21321"
                               filterable
                               :disabled="!curRowInfo.isEdit"
                               class="myChnlInput">
                      <el-option v-for="item in etcUserTypeList"
                                 :key="item.value"
                                 :label="item.text"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
                <legend> 健康码检测设备 </legend>
                 <el-form>
                  <el-row>
                  <el-col :span="4"
                          class="el-form-item__label myChnlLableClass">IP地址/链接::</el-col>
                  <el-col :span="6">
                         <el-input v-model="chnlDeviceInfoObject.p21378"
                              :disabled="!curRowInfo.isEdit"
                              class="myChnlInput"></el-input>
                  </el-col>
                  </el-row>
                 </el-form>
            </fieldset>
          </el-tab-pane>
          <el-tab-pane label="其他设置">
            <fieldset>
              <legend style="padding-top: 5px">机器人设置</legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="160px"
                       style="margin-top:10px;">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="机器人IP::">
                      <el-input v-model="chnlDeviceInfoObject.p22020"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                      <span>&nbsp;&nbsp;</span>
                      <el-checkbox v-model="chnlDeviceInfoObject.p22030"
                                   :disabled="!curRowInfo.isEdit">启用扫码枪</el-checkbox>
                      <el-checkbox v-model="chnlDeviceInfoObject.p22040"
                                   :disabled="!curRowInfo.isEdit">启用打印机</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12"
                          v-if="is_out">
                    <el-form-item label="直付二维码::">
                      <el-input v-model="chnlDeviceInfoObject.p22041"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12"
                          v-else>
                    <el-form-item label="无牌车二维码::">
                      <el-input v-model="chnlDeviceInfoObject.p22042"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="padding-top: 5px">其他设置</legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="160px"
                       style="margin-top:10px;">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="[DF]二次开闸设备IP::">
                      <el-input v-model="chnlDeviceInfoObject.p21330"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                      <span>&nbsp;&nbsp;</span>
                      <el-checkbox v-model="chnlDeviceInfoObject.p21331"
                                   :disabled="!curRowInfo.isEdit">每次都发开闸指令（此选项勾选后需关闭道闸计数功能）</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="[DF]扫码设备IP::">
                      <el-input v-model="chnlDeviceInfoObject.p21340"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="[[DF]软呼叫通道序列号::">
                      <el-input v-model="chnlDeviceInfoObject.p21344"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="[DF]对讲设备序列号::">
                      <el-input v-model="chnlDeviceInfoObject.p21342"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="[DF]全景相机序列号::">
                      <el-input v-model="chnlDeviceInfoObject.p21343"
                                style="width:200px"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="padding-top: 5px">上海路政2019公交卡设备配置</legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="120px"
                       style="margin-top:10px;">
                <el-row>
                    <el-col :span="6">
                    <el-form-item label="设备厂家::">
                      <el-select v-model="chnlDeviceInfoObject.p21351"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 placeholder="请选择设备"
                                 class="myChnlInput">
                        <el-option v-for="item in shra2019GJKProdList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="COM端口号::">
                      <el-select v-model="chnlDeviceInfoObject.p21350"
                                 filterable
                                 :disabled="!curRowInfo.isEdit"
                                 placeholder="请选择端口号"
                                 class="myChnlInput">
                        <el-option v-for="item in shra2019GJKComList"
                                   :key="item.value"
                                   :label="item.text"
                                   :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="设备编码::">
                      <el-input v-model="chnlDeviceInfoObject.p21360"
                                :disabled="!curRowInfo.isEdit"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="">
                      <el-checkbox v-model="chnlDeviceInfoObject.p21371"
                                   :disabled="!curRowInfo.isEdit">启用P+R进出场</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="padding-top: 5px">蚂蚁智行ETC配置</legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="150px"
                       style="margin-top:10px;">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="ETC通道编号::">
                      <el-input v-model="chnlDeviceInfoObject.p21370"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="珠海交警平台卡口ID::">
                      <el-input v-model="chnlDeviceInfoObject.p21373"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="padding-top: 5px">通道经纬度设置</legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="150px"
                       style="margin-top:10px;">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="经度::">
                      <el-input v-model="chnlDeviceInfoObject.p21382"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="纬度::">
                      <el-input v-model="chnlDeviceInfoObject.p21383"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="高度::">
                      <el-input v-model="chnlDeviceInfoObject.p21384"
                                :disabled="!curRowInfo.isEdit"
                                style="width:200px"
                                class="myChnlInput"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
            <fieldset>
              <legend style="padding-top: 5px"></legend>
              <el-form :model="chnlDeviceInfoObject"
                       label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="">
                      <el-checkbox v-model="chnlDeviceInfoObject.p21372"
                                   :disabled="!curRowInfo.isEdit">本通道启用云座席</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </fieldset>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('form')"
                     v-if="curRowInfo.isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="chnlEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
export default {
  name: 'channelMain.vue',
  data () {
    return {
      navigationMap: {
        chnlList: '通道列表',
        synChnlList: '待同步'
      },
      defaultValue: {
        crtIoList_defaultValue: '',
        camList_defaultValue: '',
        ledMainList_defaultValue: '',
        ledMainTypeList_defaultValue: '',
        ledSubList_defaultValue: '',
        ledSubTypeList_defaultValue: '',
        ledFullList_defaultValue: '',
        ledFullTypeList_defaultValue: '',
        voiceList_defaultValue: '',
        voiceTypeList_defaultValue: '',
        chnlGateList_defaultValue: '',
        chnlTypeList_defaultValue: '',
        remoteOpenGateList_defaultValue: '',
        rmtCtlOpenTypeList_defaultValue: '',
        devList_defaultValue: '',
        delayMgrList_defaultValue: '',
        closeTypeList_defaultValue: '',
        closeTimeList_defaultValue: '',
        etcTypeList_defaultValue: '',
        etcUserTypeList_defaultValue: '',
        tmpCarInTypeList_defaultValue: '',
        tmpCarWaitDelayList_defaultValue: '',
        tmpCarTimeOutTypeList_defaultValue: '',
        shra2019GJKComList_defaultValue: '',
        monHSTypeList_defaultValue: '',
        tempHSTypeList_defaultValue: '',
        othCardInTypeList_defaultValue: ''
      },
      is_out: false,
      loading: false,
      is_edit: false,
      is_del: false,
      is_syn: false,
      save_msg: '保存',
      save_loading: false,
      chnlActiveName: 'chnlList',
      voiceParamSetting: false,
      ledParamDes: '@余位         显示场库余位数 此参数占用一行<br/>',
      ledParamExample: '填写<br/>@余位<br/>显示<br/>余位:001',
      ledParamSelect: '1',
      ledParamUI: false,
      ledColors: ['@红色', '@绿色', '@橙色'],
      rowCol: [1, 2, 3, 4, 5, 6],
      selectChnlGateValue: '',
      shra2019GJKProdList: [{text: '无', value: '0'}, {text: 'SH-JY', value: '1'}, {text: 'SH-MGT', value: '2'}],
      timeToComboBoxList: [],
      time: [],
      camList: [],
      crtIoList: [],
      ledMainList: [],
      ledMainTypeList: [],
      ledSubList: [],
      ledSubTypeList: [],
      ledFullList: [],
      ledFullTypeList: [],
      voiceList: [],
      voiceTypeList: [],
      chnlTypeList: [],
      chnlGateList: [],
      comPortList: [],
      remoteOpenGateList: [],
      rmtCtlOpenTypeList: [],
      delayMgrList: [],
      devList: [],
      volList: [],
      closeTypeList: [],
      closeTimeList: [],
      etcTypeList: [],
      etcUserTypeList: [],
      shra2019GJKComList: [],
      tmpCarInTypeList: [],
      tmpCarWaitDelayList: [],
      tmpCarTimeOutTypeList: [],
      monCarInTypeList: [],
      monCarWaitDelayList: [],
      monCarTimeOutTypeList: [],
      monHSTypeList: [],
      tempHSTypeList: [],
      othCardInTypeList: [],
      selCustID: '',
      choiceCusts: [],
      chnlLedInnerObject: {},
      innerVisible: false,
      lcdVisible: false,
      isShowCodeUrl: false,
      chnlDeviceInfoObject: {
        p21010: '',
        p21082: '',
        p21080: '',
        p21092: '',
        p21090: '',
        p21102: '',
        p21100: '',
        p21130: '',
        p21140: '',
        p21342: '',
        p21343: '',
        p21110: '',
        p21190: '',
        p21210: '',
        p21220: '',
        p21200: '',
        p21020: '',
        p21021: '',
        p21022: '',
        p21081: '',
        p21091: '',
        p21101: '',
        p21150: '',
        p21170: '',
        p21180: '',
        p21160: '',
        p21163: '',
        p21164: '',
        p21165: '',
        p21181: '',
        p30011: '',
        p30012: '',
        p30013: '',
        p30014: '',
        p30015: '',
        p30016: '',
        p30017: '',
        p30030: '',
        p30031: '',
        p30032: '',
        p30033: '',
        p30034: '',
        p30035: '',
        p30036: '',
        p30037: '',
        p30050: '',
        p30010: '',
        p30051: '',
        p30052: '',
        p30053: '',
        p30054: '',
        p30055: '',
        p30056: '',
        // p30057: '',
        p30090: '',
        p30091: '',
        p30092: '',
        p30093: '',
        p30094: '',
        P30095: '',
        P30096: '',
        // P30097: '',
        p21230: '',
        p21240: '',
        p21250: '',
        p21260: '',
        p30061: '',
        p30062: '',
        p30063: '',
        p30064: '',
        p30065: '',
        p30066: '',
        p30067: '',
        p30071: '',
        p30072: '',
        p30073: '',
        p30074: '',
        p30075: '',
        p30076: '',
        p30077: '',
        p30081: '',
        p30082: '',
        p30083: '',
        p30084: '',
        p30085: '',
        p30086: '',
        p30087: '',
        p21120: '',
        p21121: '',
        p21023: '',
        p21025: '',
        p21043: '',
        p21024: false,
        p21026: false,
        p21310: '',
        p21350: '',
        p21321: '',
        p21320: '',
        p21378: '',
        p21351: '0',
        ledSettingIndex: 0,
        txtDevUser: '',
        txtDevPwd: '',
        cboRow: 1,
        cboCol: 1,
        tbCnt1: '',
        tbCarPassMessage1: '',
        cboClr1: '@红色',
        chkFixed1: false,
        tbCnt2: '',
        tbCarPassMessage2: '',
        cboClr2: '@红色',
        chkFixed2: false,
        tbCnt3: '',
        tbCarPassMessage3: '',
        cboClr3: '@红色',
        chkFixed3: false,
        tbCnt4: '',
        tbCarPassMessage4: '',
        cboClr4: '@红色',
        chkFixed4: false,
        carCodeTip: '',
        carCode: '',
        content1: '',
        content2: '',
        content3: '',
        content4: '',
        content5: '',
        content6: '',
        noCarCode: '',
        p22020: '',
        p22030: false,
        p22040: false,
        p21331: false,
        p21371: false,
        p21372: false,
        p22041: '',
        p22042: '',
        p21330: '',
        p21340: '',
        p21344: '',
        p21360: '',
        p21370: '',
        p21373: '',
        p21382: '',
        p21383: '',
        p21384: ''
      },
      chnlPassInfoObject: {
        p20040: false,
        p20030: false,
        p20020: false,
        p20070: false,
        p20060: false,
        p20090: false,
        p21380: false,
        p21381: '',
        p20091: '00:00',
        p20092: '00:00',
        p21375: '',
        p21377: '',
        p20100: '',
        p20080: '',
        p20081: false,
        p20082: '0',
        p21270: '',
        p21290: '',
        p20031: '',
        p20032: '',
        p20033: '',
        p20041: '',
        p20042: '',
        p20043: '',
        p21374: false,
        p21376: false,
        p20044: false,
        p20045: false,
        p21280: '',
        p21300: false,
        p20083: false
      },
      curRowInfo: {
        fCustNo: '',
        fCustID: '',
        fParkID: '',
        fChnlNo: '',
        fChnlName: '',
        fAddress: '',
        fChnlTypeID: '',
        fLinkman: '',
        fLinkPhone: ''
      },
      chnlOtherParamObject: {
        fCPUID: '',
        fMacAddr: '',
        fPriIP: ''
      },
      editOrDetail: 'chnlInfo',
      chnlEditOrDetailVisible: false,
      detailTitle: '查看通道信息',
      chnlPassInfoList: [],
      chnlDeviceInfoList: [],
      chnlBaseInfoList: [],
      chnlDetailVisible: false,
      activeName: 'chnlBaseInfo',
      choiceParks: [],
      parks: [],
      selfParkID: '',
      fChnlNo: '',
      chnlList: [],
      synChnlList: [],
      tableHeight: 200,
      form: {

      },
      pageSize: 20,
      pageNo: 1,
      total: 0
    }
  },
  computed: {
    led1: function () {
      if (!(this.chnlDeviceInfoObject.p21080 === '1' || this.chnlDeviceInfoObject.p21080 === '3' || this.chnlDeviceInfoObject.p21080 === '10')) {
        return 'line-height: 30px;padding-left: 15px;opacity:0.2;text-decoration: none'
      } else {
        return 'line-height: 30px;padding-left: 15px;opacity:1;text-decoration: none'
      }
    },
    led2: function () {
      if (!(this.chnlDeviceInfoObject.p21090 === '1' || this.chnlDeviceInfoObject.p21090 === '3' || this.chnlDeviceInfoObject.p21090 === '10')) {
        return 'line-height: 30px;padding-left: 15px;opacity:0.2;text-decoration: none'
      } else {
        return 'line-height: 30px;padding-left: 15px;opacity:1;text-decoration: none'
      }
    },
    led3: function () {
      if (!(this.chnlDeviceInfoObject.p21100 === '1' || this.chnlDeviceInfoObject.p21100 === '3' || this.chnlDeviceInfoObject.p21100 === '10')) {
        return 'line-height: 30px;padding-left: 15px;opacity:0.2;text-decoration: none'
      } else {
        return 'line-height: 30px;padding-left: 15px;opacity:1;text-decoration: none'
      }
    },
    led4: function () {
      if (this.chnlDeviceInfoObject.p21140 === '0') {
        return 'line-height: 30px;padding-left: 15px;opacity:0.2;text-decoration: none'
      } else {
        return 'line-height: 30px;padding-left: 15px;opacity:1;text-decoration: none'
      }
    },
    led5: function () {
      if (this.chnlDeviceInfoObject.p21240 === '0') {
        return 'line-height: 30px;padding-left: 15px;opacity:0.2;text-decoration: none'
      } else {
        return 'line-height: 30px;padding-left: 15px;opacity:1;text-decoration: none'
      }
    },
    chnl_ShareChnlInPark: function () {
      return this.chnlPassInfoObject.p20060 && this.curRowInfo && this.curRowInfo.fChnlTypeID === '201'
    }
  },
  watch: {
    'chnlDeviceInfoObject.chkFixed1' (newValue, oldValue) {
      if (newValue) {
        this.chnlDeviceInfoObject.tbCarPassMessage1 = ''
      }
    },
    'chnlDeviceInfoObject.chkFixed2' (newValue, oldValue) {
      if (newValue) {
        this.chnlDeviceInfoObject.tbCarPassMessage2 = ''
      }
    },
    'chnlDeviceInfoObject.chkFixed3' (newValue, oldValue) {
      if (newValue) {
        this.chnlDeviceInfoObject.tbCarPassMessage3 = ''
      }
    },
    'chnlDeviceInfoObject.chkFixed4' (newValue, oldValue) {
      if (newValue) {
        this.chnlDeviceInfoObject.tbCarPassMessage4 = ''
      }
    },
    ledParamSelect: function () {
      switch (this.ledParamSelect) {
        case '1':
          this.ledParamDes = '@余位         显示场库余位数 此参数占用一行<br/>'
          this.ledParamExample = '填写<br/>@余位<br/>显示<br/>余位:001'
          break
        case '2':
          this.ledParamDes = '@进场时间     显示进场时间  只能在出口处使用 只能在过车消息处使用 此参数占用一行<br/>'
          this.ledParamExample = '填写<br/>进场时间:@进场时间<br/>显示<br/>进场时间:2019-01-01 00:00:00'
          break
        case '3':
          this.ledParamDes = '@出场时间     显示出场时间  只能在出口处使用 只能在过车消息处使用 此参数占用一行<br/>'
          this.ledParamExample = '填写<br/>出场时间:@出场时间<br/>显示<br/>出场时间:2019-01-01 23:59:59'
          break
        case '4':
          this.ledParamDes = '@停留时间     离场停留时间  只能在出口处使用 只能在过车消息处使用 此参数占用一行<br/>'
          this.ledParamExample = '填写<br/>停留时间:@停留时间<br/>显示<br/>停留时间:1天01小时34分钟50秒'
          break
        case '5':
          this.ledParamDes = '@收费金额     显示应付金额  只能在出口处使用 只能在过车消息处使用 此参数需配合字符使用<br/>'
          this.ledParamExample = '填写<br/>应收:@收费金额元<br/>显示<br/>应收:¥10.00元'
          break
        case '6':
          this.ledParamDes = '@日期星期时间 在屏幕显示当前时间 此参数占用一行 可在进出口使用<br/>'
          this.ledParamExample = '填写<br/>@日期星期时间<br/>显示<br/>2019-01-01 星期二 14:00：30'
          break
        case '7':
          this.ledParamDes = '@车牌         在屏幕显示当前过车车牌 此参数可在进出口使用 只能在过车消息处使用<br/>'
          this.ledParamExample = '填写<br/>@车牌<br/>显示<br/>沪A12345'
          break
        case '8':
          this.ledParamDes = '@消息         此参数在过车时会自动替换成对应的提示信息，如请通行等 只能在过车消息处使用<br/>'
          this.ledParamExample = '填写<br/>@消息<br/>显示<br/>请通行等'
          break
      }
    }
    // selCustID: function () {
    //   this.setPark(this.selCustID)
    // },
    // selfParkID: function () {
    //   // this.initData()
    // }
  },
  methods: {
    ...mapActions([
      'getParkList', 'getChannelByQuery', 'getChannelParamById', 'getCustByGroup', 'getChannelSelectParam', 'saveChannel', 'deleteChannel', 'synChnlById', 'getCurrentUserPers'
    ]),
    ledSettingSave (type) {
      let obj = this.chnlDeviceInfoObject.ledSettingIndex
      if (type === 'led') {
        let pLedRowsCols = this.chnlDeviceInfoObject.cboRow + ',' + this.chnlDeviceInfoObject.cboCol
        let mytmp = this.chnlDeviceInfoObject
        let pLed1RowCnt = (mytmp.chkFixed1 ? '1' : '0') + ',' + mytmp.cboClr1 + ',' + mytmp.tbCarPassMessage1 + ',' + mytmp.tbCnt1
        let pLed2RowCnt = (mytmp.chkFixed2 ? '1' : '0') + ',' + mytmp.cboClr2 + ',' + mytmp.tbCarPassMessage2 + ',' + mytmp.tbCnt2
        let pLed3RowCnt = (mytmp.chkFixed3 ? '1' : '0') + ',' + mytmp.cboClr3 + ',' + mytmp.tbCarPassMessage3 + ',' + mytmp.tbCnt3
        let pLed4RowCnt = (mytmp.chkFixed4 ? '1' : '0') + ',' + mytmp.cboClr4 + ',' + mytmp.tbCarPassMessage4 + ',' + mytmp.tbCnt4
        let pDevUser = this.chnlDeviceInfoObject.txtDevUser
        let pDevPwd = this.chnlDeviceInfoObject.txtDevPwd
        let codeUrl = this.chnlDeviceInfoObject.carCode
        if (obj === 1) {
          this.chnlDeviceInfoObject.p30010 = pLedRowsCols
          this.chnlDeviceInfoObject.p30011 = pLed1RowCnt
          this.chnlDeviceInfoObject.p30012 = pLed2RowCnt
          this.chnlDeviceInfoObject.p30013 = pLed3RowCnt
          this.chnlDeviceInfoObject.p30014 = pLed4RowCnt
          this.chnlDeviceInfoObject.p30015 = pDevUser
          this.chnlDeviceInfoObject.p30016 = pDevPwd
          this.chnlDeviceInfoObject.p30017 = codeUrl
        } else if (obj === 2) {
          this.chnlDeviceInfoObject.p30030 = pLedRowsCols
          this.chnlDeviceInfoObject.p30031 = pLed1RowCnt
          this.chnlDeviceInfoObject.p30032 = pLed2RowCnt
          this.chnlDeviceInfoObject.p30033 = pLed3RowCnt
          this.chnlDeviceInfoObject.p30034 = pLed4RowCnt
          this.chnlDeviceInfoObject.p30035 = pDevUser
          this.chnlDeviceInfoObject.p30036 = pDevPwd
          this.chnlDeviceInfoObject.p30037 = codeUrl
        } else if (obj === 3) {
          this.chnlDeviceInfoObject.p30050 = pLedRowsCols
          this.chnlDeviceInfoObject.p30051 = pLed1RowCnt
          this.chnlDeviceInfoObject.p30052 = pLed2RowCnt
          this.chnlDeviceInfoObject.p30053 = pLed3RowCnt
          this.chnlDeviceInfoObject.p30054 = pLed4RowCnt
          this.chnlDeviceInfoObject.p30055 = pDevUser
          this.chnlDeviceInfoObject.p30056 = pDevPwd
          // this.chnlDeviceInfoObject.p30057 = codeUrl
        } else if (obj === 4) {
          this.chnlDeviceInfoObject.p30090 = pLedRowsCols
          this.chnlDeviceInfoObject.p30091 = pLed1RowCnt
          this.chnlDeviceInfoObject.p30092 = pLed2RowCnt
          this.chnlDeviceInfoObject.p30093 = pLed3RowCnt
          this.chnlDeviceInfoObject.p30094 = pLed4RowCnt
          this.chnlDeviceInfoObject.p30095 = pDevUser
          this.chnlDeviceInfoObject.p30096 = pDevPwd
          // this.chnlDeviceInfoObject.p30097 = codeUrl
        }
        this.innerVisible = false
      } else if (type === 'lcd') {
        if (obj === 1) {
          this.chnlDeviceInfoObject.p30061 = this.chnlDeviceInfoObject.content1
          this.chnlDeviceInfoObject.p30062 = this.chnlDeviceInfoObject.content2
          this.chnlDeviceInfoObject.p30063 = this.chnlDeviceInfoObject.content3
          this.chnlDeviceInfoObject.p30064 = this.chnlDeviceInfoObject.content4
          this.chnlDeviceInfoObject.p30065 = this.chnlDeviceInfoObject.content5
          this.chnlDeviceInfoObject.p30066 = this.chnlDeviceInfoObject.content6
          this.chnlDeviceInfoObject.p30067 = this.chnlDeviceInfoObject.noCarCode
          this.lcdVisible = false
        } else if (obj === 2) {
          if (this.chnlDeviceInfoObject.p21090 !== '0') {
            this.chnlDeviceInfoObject.p30071 = this.chnlDeviceInfoObject.content1
            this.chnlDeviceInfoObject.p30072 = this.chnlDeviceInfoObject.content2
            this.chnlDeviceInfoObject.p30073 = this.chnlDeviceInfoObject.content3
            this.chnlDeviceInfoObject.p30074 = this.chnlDeviceInfoObject.content4
            this.chnlDeviceInfoObject.p30075 = this.chnlDeviceInfoObject.content5
            this.chnlDeviceInfoObject.p30076 = this.chnlDeviceInfoObject.content6
            this.chnlDeviceInfoObject.p30077 = this.chnlDeviceInfoObject.noCarCode
            this.lcdVisible = false
          }
        } else if (obj === 3) {
          if (this.chnlDeviceInfoObject.p21100 !== '0') {
            this.chnlDeviceInfoObject.p30081 = this.chnlDeviceInfoObject.content1
            this.chnlDeviceInfoObject.p30082 = this.chnlDeviceInfoObject.content2
            this.chnlDeviceInfoObject.p30083 = this.chnlDeviceInfoObject.content3
            this.chnlDeviceInfoObject.p30084 = this.chnlDeviceInfoObject.content4
            this.chnlDeviceInfoObject.p30085 = this.chnlDeviceInfoObject.content5
            this.chnlDeviceInfoObject.p30086 = this.chnlDeviceInfoObject.content6
            this.chnlDeviceInfoObject.p30087 = this.chnlDeviceInfoObject.noCarCode
            this.lcdVisible = false
          }
        }
      }
    },
    tabClick () {
      this.pageNo = 1
      this.total = 0
      this.initData()
    },
    setDefault () {
      for (let key in this.curRowInfo) {
        this.curRowInfo[key] = ''
      }
      for (let key in this.chnlPassInfoObject) {
        this.chnlPassInfoObject[key] = ''
      }
      for (let key in this.chnlDeviceInfoObject) {
        this.chnlDeviceInfoObject[key] = ''
      }
      this.chnlDeviceInfoObject.cboClr1 = '@红色'
      this.chnlDeviceInfoObject.cboClr2 = '@红色'
      this.chnlDeviceInfoObject.cboClr3 = '@红色'
      this.chnlDeviceInfoObject.cboClr4 = '@红色'
      this.chnlDeviceInfoObject.p22030 = false
      this.chnlDeviceInfoObject.p22040 = false
      this.chnlDeviceInfoObject.p21331 = false
      this.chnlDeviceInfoObject.p21371 = false
      this.chnlDeviceInfoObject.p21372 = false
      this.chnlDeviceInfoObject.p21351 = '0'
    },
    submitForm (formName) {
      if ((this.curRowInfo.fCustID || '').trim().length <= 0) {
        this.$message.error('请选择客户')
        return false
      }
      if ((this.curRowInfo.fParkID || '').trim().length <= 0) {
        this.$message.error('请选择场库')
        return false
      }
      if (this.chnl_ShareChnlInPark) {
        if ((this.chnlPassInfoObject.p20080 || '').trim().length <= 0) {
          this.$message.error('请选择【本通道是两场库公用通道】进场场库')
          return false
        }
        if (this.curRowInfo.fParkID === this.chnlPassInfoObject.p20080) {
          this.$message.error('【本通道是两场库公用通道】进场场库不能与该通道的场库相同')
          return false
        }
      }
      if (this.chnlPassInfoObject.p20020) {
        if ((this.chnlPassInfoObject.p21270 || '').trim().length <= 0) {
          this.$message.error('请选择处理延时（秒）')
          return false
        }
      }
      if (this.chnlPassInfoObject.p20070) {
        if ((this.chnlPassInfoObject.p21290 || '').trim().length <= 0) {
          this.$message.error('请选择出场方式')
          return false
        }
      }
      if (this.chnlPassInfoObject.p20070 && (this.chnlPassInfoObject.p21290 || '').trim().length > 0 && this.chnlPassInfoObject.p21290 !== '0') {
        if ((this.chnlPassInfoObject.p21280 || '').trim().length <= 0) {
          this.$message.error('请选择等待延时（秒）')
          return false
        }
      }
      if (this.chnlPassInfoObject.p21380) {
        if (this.chnlPassInfoObject.p21381 < 1 || this.chnlPassInfoObject.p21381 > 5) {
          this.$message.error('最小识别间隔请输入数字（范围1-5）')
          return false
        }
      }
      this.save_loading = true
      this.save_msg = '保存中…'
      let param = {}
      param.curRowInfo = this.curRowInfo
      param.chnlDeviceInfoObject = this.chnlDeviceInfoObject
      param.chnlOtherParamObject = this.chnlOtherParamObject
      param.chnlPassInfoObject = this.chnlPassInfoObject
      this.saveChannel(param).then(res => {
        this.save_loading = false
        this.save_msg = '保存'
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.chnlEditOrDetailVisible = false
            this.initData()
            this.$message.success(data.Msg)
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    addSyncChannel () {
      this.editOrDetail = 'chnlInfo'
      this.detailTitle = '新增通道'
      this.setDefault()
      this.setDDL()
      this.is_out = false
      this.curRowInfo.isEdit = true
      this.chnlEditOrDetailVisible = true
      this.curRowInfo.op = 'add'
    },
    bindQuery () {
      this.initData()
    },
    voiceSetting () {
      this.voiceParamSetting = true
    },
    ledSetting (type, obj) {
      this.chnlDeviceInfoObject.ledSettingIndex = obj
      if (type === '1' || type === '3' || (type === '11' && obj === 4)) { // led
        let pLedRowsCols
        let pLed1RowCnt
        let pLed2RowCnt
        let pLed3RowCnt
        let pLed4RowCnt
        let pDevUser
        let pDevPwd
        let codeUrl
        this.chnlDeviceInfoObject.txtDevUser = ''
        this.chnlDeviceInfoObject.txtDevPwd = ''
        this.chnlDeviceInfoObject.cboRow = ''
        this.chnlDeviceInfoObject.cboCol = ''
        this.chnlDeviceInfoObject.tbCnt1 = ''
        this.chnlDeviceInfoObject.tbCarPassMessage1 = ''
        this.chnlDeviceInfoObject.cboClr1 = this.ledColors[0]
        this.chnlDeviceInfoObject.chkFixed1 = false
        this.chnlDeviceInfoObject.tbCnt2 = '智能识别'
        this.chnlDeviceInfoObject.tbCarPassMessage2 = '@车牌'
        this.chnlDeviceInfoObject.cboClr2 = this.ledColors[0]
        this.chnlDeviceInfoObject.chkFixed2 = false
        this.chnlDeviceInfoObject.tbCnt3 = '一车一杆'
        this.chnlDeviceInfoObject.tbCarPassMessage3 = '@消息'
        this.chnlDeviceInfoObject.cboClr3 = this.ledColors[0]
        this.chnlDeviceInfoObject.chkFixed3 = false
        this.chnlDeviceInfoObject.tbCnt4 = '@日期星期时间'
        this.chnlDeviceInfoObject.tbCarPassMessage4 = ''
        this.chnlDeviceInfoObject.cboClr4 = this.ledColors[0]
        this.chnlDeviceInfoObject.chkFixed4 = false
        this.chnlDeviceInfoObject.carCodeTip = ''
        this.chnlDeviceInfoObject.carCode = ''
        this.isShowCodeUrl = false
        if (obj === 1) {
          if (this.chnlDeviceInfoObject.p21080 !== '0') {
            let inputVal = $('#input_21080').val()
            inputVal = inputVal.replace('[LED]', '')
            if (this.is_out) {
              this.chnlDeviceInfoObject.carCodeTip = inputVal + '出口直付二维码::'
            } else {
              this.chnlDeviceInfoObject.carCodeTip = inputVal + '无牌车进场二维码::'
            }
            pLedRowsCols = this.chnlDeviceInfoObject.p30010
            pLed1RowCnt = this.chnlDeviceInfoObject.p30011
            pLed2RowCnt = this.chnlDeviceInfoObject.p30012
            pLed3RowCnt = this.chnlDeviceInfoObject.p30013
            pLed4RowCnt = this.chnlDeviceInfoObject.p30014
            pDevUser = this.chnlDeviceInfoObject.p30015
            pDevPwd = this.chnlDeviceInfoObject.p30016
            codeUrl = this.chnlDeviceInfoObject.p30017
            this.isShowCodeUrl = true
            this.innerVisible = true
          }
        } else if (obj === 2) {
          if (this.chnlDeviceInfoObject.p21090 !== '0') {
            let inputVal = $('#input_21090').val()
            inputVal = inputVal.replace('[LED]', '')
            if (this.is_out) {
              this.chnlDeviceInfoObject.carCodeTip = inputVal + '出口直付二维码::'
            } else {
              this.chnlDeviceInfoObject.carCodeTip = inputVal + '无牌车进场二维码::'
            }
            pLedRowsCols = this.chnlDeviceInfoObject.p30030
            pLed1RowCnt = this.chnlDeviceInfoObject.p30031
            pLed2RowCnt = this.chnlDeviceInfoObject.p30032
            pLed3RowCnt = this.chnlDeviceInfoObject.p30033
            pLed4RowCnt = this.chnlDeviceInfoObject.p30034
            pDevUser = this.chnlDeviceInfoObject.p30035
            pDevPwd = this.chnlDeviceInfoObject.p30036
            codeUrl = this.chnlDeviceInfoObject.p30037
            this.isShowCodeUrl = true
            this.innerVisible = true
          }
        } else if (obj === 3) {
          if (this.chnlDeviceInfoObject.p21100 !== '0') {
            // let inputVal = $('#input_21100').val()
            // inputVal = inputVal.replace('[LED]', '')
            // if (this.is_out) {
            //   this.chnlDeviceInfoObject.carCodeTip = inputVal + '出口直付二维码::'
            // } else {
            //   this.chnlDeviceInfoObject.carCodeTip = inputVal + '无牌车进场二维码::'
            // }
            pLedRowsCols = this.chnlDeviceInfoObject.p30050
            pLed1RowCnt = this.chnlDeviceInfoObject.p30051
            pLed2RowCnt = this.chnlDeviceInfoObject.p30052
            pLed3RowCnt = this.chnlDeviceInfoObject.p30053
            pLed4RowCnt = this.chnlDeviceInfoObject.p30054
            pDevUser = this.chnlDeviceInfoObject.p30055
            pDevPwd = this.chnlDeviceInfoObject.p30056
            // codeUrl = this.chnlDeviceInfoObject.p30057
            this.innerVisible = true
          }
        } else if (obj === 4) {
          if (this.chnlDeviceInfoObject.p21240 !== '0') {
            // let inputVal = $('#input_21240').val()
            // inputVal = inputVal.replace('[LED]', '')
            // if (this.is_out) {
            //   this.chnlDeviceInfoObject.carCodeTip = inputVal + '出口直付二维码::'
            // } else {
            //   this.chnlDeviceInfoObject.carCodeTip = inputVal + '无牌车进场二维码::'
            // }
            pLedRowsCols = this.chnlDeviceInfoObject.p30090
            pLed1RowCnt = this.chnlDeviceInfoObject.p30091
            pLed2RowCnt = this.chnlDeviceInfoObject.p30092
            pLed3RowCnt = this.chnlDeviceInfoObject.p30093
            pLed4RowCnt = this.chnlDeviceInfoObject.p30094
            pDevUser = this.chnlDeviceInfoObject.p30095
            pDevPwd = this.chnlDeviceInfoObject.p30096
            // codeUrl = this.chnlDeviceInfoObject.p30097
            this.innerVisible = true
          }
        }
        if (this.innerVisible) {
          var arrpLedRowsCols = pLedRowsCols.split(',')
          if (arrpLedRowsCols.length >= 2) {
            this.chnlDeviceInfoObject.cboRow = arrpLedRowsCols[0]
            this.chnlDeviceInfoObject.cboCol = arrpLedRowsCols[1]

            var arr = pLed1RowCnt.split(',')
            this.chnlDeviceInfoObject.tbCarPassMessage1 = arr[2]
            this.chnlDeviceInfoObject.cboClr1 = arr[1]
            this.chnlDeviceInfoObject.tbCnt1 = arr[3]
            this.chnlDeviceInfoObject.chkFixed1 = arr[0] === '1'

            arr = pLed2RowCnt.split(',')
            this.chnlDeviceInfoObject.tbCarPassMessage2 = arr[2]
            this.chnlDeviceInfoObject.cboClr2 = arr[1]
            this.chnlDeviceInfoObject.tbCnt2 = arr[3]
            this.chnlDeviceInfoObject.chkFixed2 = arr[0] === '1'

            arr = pLed3RowCnt.split(',')
            this.chnlDeviceInfoObject.tbCarPassMessage3 = arr[2]
            this.chnlDeviceInfoObject.cboClr3 = arr[1]
            this.chnlDeviceInfoObject.tbCnt3 = arr[3]
            this.chnlDeviceInfoObject.chkFixed3 = arr[0] === '1'

            arr = pLed4RowCnt.split(',')
            this.chnlDeviceInfoObject.tbCarPassMessage4 = arr[2]
            this.chnlDeviceInfoObject.cboClr4 = arr[1]
            this.chnlDeviceInfoObject.tbCnt4 = arr[3]
            this.chnlDeviceInfoObject.chkFixed4 = arr[0] === '1'
            this.chnlDeviceInfoObject.txtDevUser = pDevUser
            this.chnlDeviceInfoObject.txtDevPwd = pDevPwd
            this.chnlDeviceInfoObject.carCode = codeUrl
          }
        }
      } else if (type === '10') { // lcd
        this.chnlDeviceInfoObject.content1 = ''
        this.chnlDeviceInfoObject.content2 = ''
        this.chnlDeviceInfoObject.content3 = ''
        this.chnlDeviceInfoObject.content4 = ''
        this.chnlDeviceInfoObject.content5 = ''
        this.chnlDeviceInfoObject.content6 = ''
        this.chnlDeviceInfoObject.noCarCode = ''
        if (obj === 1) {
          if (this.chnlDeviceInfoObject.p21080 !== '0') {
            this.chnlDeviceInfoObject.content1 = this.chnlDeviceInfoObject.p30061
            this.chnlDeviceInfoObject.content2 = this.chnlDeviceInfoObject.p30062
            this.chnlDeviceInfoObject.content3 = this.chnlDeviceInfoObject.p30063
            this.chnlDeviceInfoObject.content4 = this.chnlDeviceInfoObject.p30064
            this.chnlDeviceInfoObject.content5 = this.chnlDeviceInfoObject.p30065
            this.chnlDeviceInfoObject.content6 = this.chnlDeviceInfoObject.p30066
            this.chnlDeviceInfoObject.noCarCode = this.chnlDeviceInfoObject.p30067
            this.lcdVisible = true
          }
        } else if (obj === 2) {
          if (this.chnlDeviceInfoObject.p21090 !== '0') {
            this.chnlDeviceInfoObject.content1 = this.chnlDeviceInfoObject.p30071
            this.chnlDeviceInfoObject.content2 = this.chnlDeviceInfoObject.p30072
            this.chnlDeviceInfoObject.content3 = this.chnlDeviceInfoObject.p30073
            this.chnlDeviceInfoObject.content4 = this.chnlDeviceInfoObject.p30074
            this.chnlDeviceInfoObject.content5 = this.chnlDeviceInfoObject.p30075
            this.chnlDeviceInfoObject.content6 = this.chnlDeviceInfoObject.p30076
            this.chnlDeviceInfoObject.noCarCode = this.chnlDeviceInfoObject.p30077
            this.lcdVisible = true
          }
        } else if (obj === 3) {
          if (this.chnlDeviceInfoObject.p21100 !== '0') {
            this.chnlDeviceInfoObject.content1 = this.chnlDeviceInfoObject.p30081
            this.chnlDeviceInfoObject.content2 = this.chnlDeviceInfoObject.p30082
            this.chnlDeviceInfoObject.content3 = this.chnlDeviceInfoObject.p30083
            this.chnlDeviceInfoObject.content4 = this.chnlDeviceInfoObject.p30084
            this.chnlDeviceInfoObject.content5 = this.chnlDeviceInfoObject.p30085
            this.chnlDeviceInfoObject.content6 = this.chnlDeviceInfoObject.p30086
            this.chnlDeviceInfoObject.noCarCode = this.chnlDeviceInfoObject.p30087
            this.lcdVisible = true
          }
        }
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 25 - 230
      obj.tableHeight = clientHeight
    },
    indexMethod (index) {
      return this.pageSize * (this.pageNo - 1) + index + 1
    },
    handleSizeChange (value) {
      this.pageSize = value
      this.initData()
    },
    handlePage (index) {
      this.pageNo = index
      this.initData()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fIsDel === '1') {
        return 'warning-row'
      }
      return ''
    },
    changeChnlType (val) {
      this.chnlPassInfoObject = {
        p20040: false,
        p20030: false,
        p20020: false,
        p20070: false,
        p20060: false,
        p20090: false,
        p21380: false,
        p21381: '',
        p21374: false,
        p21376: false,
        p20091: '00:00',
        p20092: '00:00',
        p21300: false,
        p20083: false,
        p20080: '',
        p20081: false,
        p20082: '0',
        p21270: this.defaultValue.delayMgrList_defaultValue,
        p21290: this.defaultValue.closeTypeList_defaultValue,
        p21280: this.defaultValue.closeTimeList_defaultValue,
        p20031: this.defaultValue.tmpCarInTypeList_defaultValue,
        p20032: this.defaultValue.tmpCarWaitDelayList_defaultValue,
        p20033: this.defaultValue.tmpCarTimeOutTypeList_defaultValue,
        p20041: this.defaultValue.monCarInTypeList_defaultValue,
        p20042: this.defaultValue.monCarWaitDelayList_defaultValue,
        p20043: this.defaultValue.monCarTimeOutTypeList_defaultValue,
        p21375: this.defaultValue.monHSTypeList_defaultValue,
        p21377: this.defaultValue.tempHSTypeList_defaultValue,
        p20100: this.defaultValue.othCardInTypeList_defaultValue,
        p20044: false,
        p20045: false
      }
      if (val === '201') {
        this.is_out = true
      } else {
        this.is_out = false
      }
    },
    initData () {
      let chnlParam = {}
      chnlParam['fParkID'] = this.selfParkID
      chnlParam['fCustID'] = this.selCustID
      chnlParam['fChnlNo'] = this.fChnlNo
      chnlParam.pageSize = this.pageSize
      chnlParam.pageNo = this.pageNo
      chnlParam.chnlActiveName = this.chnlActiveName
      var isSyn = this.chnlActiveName === 'synChnlList'
      if (isSyn) {
        this.synChnlList = []
      } else {
        this.chnlList = []
      }
      this.loading = true
      this.getChannelByQuery(chnlParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // let tmpChnl = []
              // Object.assign(tmpChnl, data.Data.rows)
              if (isSyn) {
                this.synChnlList = data.Data.rows || []
              } else {
                this.chnlList = data.Data.rows || []
              }
              this.total = data.Data.total
            }
          }
        }
      })
    },
    detailClick (rowInfo) {
      this.activeName = 'chnlBaseInfo'
      this.chnlBaseInfoList = []
      this.chnlPassInfoList = []
      this.chnlDeviceInfoList = []
      if (rowInfo && rowInfo !== null && typeof (rowInfo) !== 'undefined') {
        let chnlInfo = {
          'fParkName': '场库名称',
          'fParkTypeName': '场库类型',
          'fLinkman': '通道名称',
          'fLinkPhone': '通道类型'
        }
        for (var key in chnlInfo) {
          let pinfo = {}
          pinfo['fParmName'] = chnlInfo[key]
          pinfo['fParmVal'] = rowInfo[key]
          this.chnlBaseInfoList.push(pinfo)
        }
        this.detailTitle = '查看 ' + rowInfo.fChnlName + ' 配置信息'
        this.getChannelParamById({ fCustID: rowInfo.fCustID, fChnlID: rowInfo.fChnlID, fIsSyn: this.chnlActiveName === 'synChnlList' }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                let tmpchnlPassInfoList = []
                let tmpchnlDeviceInfoList = []
                Object.assign(tmpchnlPassInfoList, data.Data.chnlPassInfoList)
                Object.assign(tmpchnlDeviceInfoList, data.Data.chnlDeviceInfoList)
                this.chnlPassInfoList = tmpchnlPassInfoList
                this.chnlDeviceInfoList = tmpchnlDeviceInfoList
                this.chnlDetailVisible = true
              }
            }
          }
        })
      }
    },
    editChannel (index, row) {
      this.editOrDetail = 'chnlInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updateChannel(row, true, 'edit')
      }
    },
    updateChannel (row, isEdit, op) {
      let curRow = {}
      row.chnlActiveName = this.chnlActiveName
      Object.assign(curRow, row)
      this.curRowInfo = curRow
      this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + row.fChnlName
      this.curRowInfo.isEdit = isEdit
      this.curRowInfo.op = op
      this.curRowInfo.fIsSyn = this.chnlActiveName === 'synChnlList'
      this.setPark(this.curRowInfo.fCustID, 1, this.curRowInfo.fParkID)
      this.changeChnlType(this.curRowInfo.fChnlTypeID)
      this.chnlPassInfoObject = {
        p20040: false,
        p20030: false,
        p20020: false,
        p20070: false,
        p20060: false,
        p20090: false,
        p21380: false,
        p21381: '',
        p21374: false,
        p21376: false,
        p20091: '00:00',
        p20092: '00:00',
        p21300: false,
        p20083: false,
        p20080: '',
        p20081: false,
        p20082: '0',
        p21270: this.defaultValue.delayMgrList_defaultValue,
        p21290: this.defaultValue.closeTypeList_defaultValue,
        p21280: this.defaultValue.closeTimeList_defaultValue,
        p20031: this.defaultValue.tmpCarInTypeList_defaultValue,
        p20032: this.defaultValue.tmpCarWaitDelayList_defaultValue,
        p20033: this.defaultValue.tmpCarTimeOutTypeList_defaultValue,
        p20041: this.defaultValue.monCarInTypeList_defaultValue,
        p20042: this.defaultValue.monCarWaitDelayList_defaultValue,
        p20043: this.defaultValue.monCarTimeOutTypeList_defaultValue,
        p21377: this.defaultValue.tempHSTypeList_defaultValue,
        p21375: this.defaultValue.monHSTypeList_defaultValue,
        p20100: this.defaultValue.othCardInTypeList_defaultValue,
        p20044: false,
        p20045: false
      }
      this.chnlDeviceInfoObject = {
        p21025: this.defaultValue.crtIoList_defaultValue,
        p21010: this.defaultValue.camList_defaultValue,
        p21082: this.defaultValue.ledMainList_defaultValue,
        p21080: this.defaultValue.ledMainTypeList_defaultValue,
        p21092: this.defaultValue.ledSubList_defaultValue,
        p21090: this.defaultValue.ledSubTypeList_defaultValue,
        p21102: this.defaultValue.ledFullList_defaultValue,
        p21100: this.defaultValue.ledFullTypeList_defaultValue,
        p21130: this.defaultValue.voiceList_defaultValue,
        p21140: this.defaultValue.voiceTypeList_defaultValue,
        p21110: this.defaultValue.chnlGateList_defaultValue,
        p21190: this.defaultValue.remoteOpenGateList_defaultValue,
        p21210: '',
        p21220: this.defaultValue.rmtCtlOpenTypeList_defaultValue,
        p21200: '',
        p21020: '',
        p21021: '',
        p21022: '',
        p21081: '',
        p21091: '',
        p21101: '',
        p21150: '',
        p21170: '',
        p21180: '',
        p21160: '',
        p21163: '',
        p21164: '',
        p21165: '',
        p21181: '',
        p30011: '',
        p30012: '',
        p30013: '',
        p30014: '',
        p30015: '',
        p30016: '',
        p30017: '',
        p30030: '',
        p30031: '',
        p30032: '',
        p30033: '',
        p30034: '',
        p30035: '',
        p30036: '',
        p30037: '',
        p30050: '',
        p30010: '',
        p30051: '',
        p30052: '',
        p30053: '',
        p30054: '',
        p30055: '',
        p30056: '',
        // p30057: '',
        p21230: '',
        p21240: this.defaultValue.devList_defaultValue,
        p21250: '',
        p30061: '',
        p30062: '',
        p30063: '',
        p30064: '',
        p30065: '',
        p30066: '',
        p30067: '',
        p30071: '',
        p30072: '',
        p30073: '',
        p30074: '',
        p30075: '',
        p30076: '',
        p30077: '',
        p30081: '',
        p30082: '',
        p30083: '',
        p30084: '',
        p30085: '',
        p30086: '',
        p30087: '',
        p21120: '',
        p21121: '',
        p21023: '',
        p21043: '',
        p21024: false,
        p21026: false,
        p30090: '',
        p30091: '',
        p30092: '',
        p30093: '',
        p30094: '',
        P30095: '',
        P30096: '',
        // P30097: '',
        p22020: '',
        p22030: false,
        p22040: false,
        p21331: false,
        p21371: false,
        p21372: false,
        p22041: '',
        p22042: '',
        p21330: '',
        p21340: '',
        p21344: '',
        p21342: '',
        p21343: '',
        p21360: '',
        p21370: '',
        p21373: '',
        p21382: '',
        p21383: '',
        p21384: '',
        p21310: this.defaultValue.etcTypeList_defaultValue,
        p21321: this.defaultValue.etcUserTypeList_defaultValue,
        p21350: this.defaultValue.shra2019GJKComList_defaultValue,
        p21320: '',
        p21378: '',
        p21351: '0',
        ledSettingIndex: 0,
        txtDevUser: '',
        txtDevPwd: '',
        cboRow: 1,
        cboCol: 1,
        tbCnt1: '',
        tbCarPassMessage1: '',
        cboClr1: '@红色',
        chkFixed1: false,
        tbCnt2: '',
        tbCarPassMessage2: '',
        cboClr2: '@红色',
        chkFixed2: false,
        tbCnt3: '',
        tbCarPassMessage3: '',
        cboClr3: '@红色',
        chkFixed3: false,
        tbCnt4: '',
        tbCarPassMessage4: '',
        cboClr4: '@红色',
        chkFixed4: false,
        carCodeTip: '',
        carCode: '',
        content1: '',
        content2: '',
        content3: '',
        content4: '',
        content5: '',
        content6: '',
        noCarCode: ''
      }
      this.chnlOtherParamObject = {
        fCPUID: '',
        fMacAddr: '',
        fPriIP: ''
      }
      this.getChannelParamById({ fCustID: row.fCustID, fChnlID: row.fChnlID, fIsSyn: this.chnlActiveName === 'synChnlList' }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              // console.log(data.Data.chnlPassInfoObject)
              Object.assign(this.chnlPassInfoObject, data.Data.chnlPassInfoObject)
              console.log(this.chnlPassInfoObject)
              Object.assign(this.chnlDeviceInfoObject, data.Data.chnlDeviceInfoObject)
              Object.assign(this.chnlOtherParamObject, data.Data.chnlOtherParamObject)
              this.chnlEditOrDetailVisible = true
            }
            console.log(this.chnlPassInfoObject.p20044)
          }
        }
      })
    },
    viewChannel (row) {
      this.editOrDetail = 'chnlInfo'
      if (row && row !== null && typeof (row) !== 'undefined') {
        this.updateChannel(row, false, 'view')
      }
      // if (row && row !== null && typeof (row) !== 'undefined') {
      //   let curRow = {}
      //   Object.assign(curRow, row)
      //   this.curRowInfo = curRow
      //   this.detailTitle = '【' + row.fCustName + '(' + row.fCustNo + ')' + '-' + row.fParkName + '】' + row.fChnlName
      // }
      // this.curRowInfo.isEdit = false
      // row.chnlActiveName = this.chnlActiveName
      // var postParam = {}
      // postParam['fCustID'] = row.fCustID
      // this.getChannelParamById(row).then(res => {
      //   let {status, data} = res
      //   if (status === 200) {
      //     if (data.IsOk) {
      //       Object.assign(this.chnlPassInfoObject, data.Data.chnlPassInfoObject)
      //       Object.assign(this.chnlDeviceInfoObject, data.Data.chnlDeviceInfoObject)
      //       this.chnlEditOrDetailVisible = true
      //     }
      //   }
      // })
    },
    deleteChnlClient (index, row) {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteChannel({ fBigRowID: row.fBigRowID, fIsSyn: this.chnlActiveName === 'synChnlList' }).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.initData()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      })
    },
    synChannel (index, row, isSyn) {
      if (row && row !== null && typeof (row) !== 'undefined') {
        var msg = ''
        if (isSyn) {
          msg = '从云平台下发同步到线下客户端'
        } else {
          msg = '从线下客户端上传同步到云平台'
        }
        this.$confirm('将客户[' + row.fCustName + ']的场库[' + row.fParkName + ']的通道[' + row.fChnlName + ']' + msg + ', 是否继续?', '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
        }).then(() => {
          this.synChnlById({
            fBigRowID: row.fBigRowID,
            fIsSyn: isSyn
          }).then(res => {
            if (res && res.data) {
              let { status, data } = res
              if (status === 200) {
                if (data.IsOk) {
                  this.$message({
                    type: 'success',
                    message: '操作完成'
                  })
                  this.initData()
                } else {
                  this.$message.error(data.Msg)
                }
              }
            }
          })
        }).catch(() => { })
      }
    },
    setPark (val, type, fParkID = '') {
      if (type === 0) {
        this.choiceParks = []
        this.selfParkID = ''
      } else if (type === 1) {
        this.parks = []
        this.chnlPassInfoObject.p20080 = ''
        if ((fParkID || '').trim().length <= 0) {
          this.curRowInfo.fParkID = ''
        }
      }
      this.getParkList({ fCustID: val }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              if (type === 0) {
                this.choiceParks = data.Data || []
              } else if (type === 1) {
                this.parks = data.Data || []
              }
            }
          }
        }
      })
    },
    setDDL () {
      this.curRowInfo.fChnlTypeID = this.defaultValue.chnlTypeList_defaultValue
      this.chnlDeviceInfoObject.p21025 = this.defaultValue.crtIoList_defaultValue
      this.chnlDeviceInfoObject.p21010 = this.defaultValue.camList_defaultValue
      this.chnlDeviceInfoObject.p21082 = this.defaultValue.ledMainList_defaultValue
      this.chnlDeviceInfoObject.p21080 = this.defaultValue.ledMainTypeList_defaultValue
      this.chnlDeviceInfoObject.p21092 = this.defaultValue.ledSubList_defaultValue
      this.chnlDeviceInfoObject.p21090 = this.defaultValue.ledSubTypeList_defaultValue
      this.chnlDeviceInfoObject.p21102 = this.defaultValue.ledFullList_defaultValue
      this.chnlDeviceInfoObject.p21100 = this.defaultValue.ledFullTypeList_defaultValue
      this.chnlDeviceInfoObject.p21130 = this.defaultValue.voiceList_defaultValue
      this.chnlDeviceInfoObject.p21140 = this.defaultValue.voiceTypeList_defaultValue
      this.chnlDeviceInfoObject.p21110 = this.defaultValue.chnlGateList_defaultValue
      this.chnlDeviceInfoObject.p21190 = this.defaultValue.remoteOpenGateList_defaultValue
      this.chnlDeviceInfoObject.p21220 = this.defaultValue.rmtCtlOpenTypeList_defaultValue
      this.chnlDeviceInfoObject.p21310 = this.defaultValue.etcTypeList_defaultValue
      this.chnlDeviceInfoObject.p21321 = this.defaultValue.etcUserTypeList_defaultValue
      this.chnlDeviceInfoObject.p21230 = '' // 扫码设备通讯端口
      this.chnlDeviceInfoObject.p21240 = this.defaultValue.devList_defaultValue
      this.chnlDeviceInfoObject.p21350 = this.defaultValue.shra2019GJKComList_defaultValue
      this.chnlDeviceInfoObject.p21260 = '' // 音量
      this.chnlPassInfoObject.p20082 = '0'
      this.chnlPassInfoObject.p20091 = '00:00'
      this.chnlPassInfoObject.p20092 = '00:00'
      this.chnlPassInfoObject.p21270 = this.defaultValue.delayMgrList_defaultValue
      this.chnlPassInfoObject.p21290 = this.defaultValue.closeTypeList_defaultValue
      this.chnlPassInfoObject.p21280 = this.defaultValue.closeTimeList_defaultValue
      this.chnlPassInfoObject.p20031 = this.defaultValue.tmpCarInTypeList_defaultValue
      this.chnlPassInfoObject.p20032 = this.defaultValue.tmpCarWaitDelayList_defaultValue
      this.chnlPassInfoObject.p20033 = this.defaultValue.tmpCarTimeOutTypeList_defaultValue
      this.chnlPassInfoObject.p20041 = this.defaultValue.monCarInTypeList_defaultValue
      this.chnlPassInfoObject.p20042 = this.defaultValue.monCarWaitDelayList_defaultValue
      this.chnlPassInfoObject.p20043 = this.defaultValue.monCarTimeOutTypeList_defaultValue
      this.chnlPassInfoObject.p21375 = this.defaultValue.monHSTypeList_defaultValue
      this.chnlPassInfoObject.p21377 = this.defaultValue.tempHSTypeList_defaultValue
      this.chnlPassInfoObject.p20100 = this.defaultValue.othCardInTypeList_defaultValue
    }
  },
  created () {
    this.getCurrentUserPers({ perTypeId: 22000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    let sizethis = this
    window.onresize = () => {
      this.setTableHeight(sizethis)
    }
    this.getCustByGroup({ fCustTypeID: 0 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
          }
        }
      }
    })
    this.initData()
    this.getChannelSelectParam({}).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            Object.assign(this.camList, data.Data.camList)
            Object.assign(this.crtIoList, data.Data.crtIoList)
            Object.assign(this.ledMainList, data.Data.ledMainList)
            Object.assign(this.ledMainTypeList, data.Data.ledMainTypeList)
            Object.assign(this.ledSubList, data.Data.ledSubList)
            Object.assign(this.ledSubTypeList, data.Data.ledSubTypeList)
            Object.assign(this.ledFullList, data.Data.ledFullList)
            Object.assign(this.ledFullTypeList, data.Data.ledFullTypeList)
            Object.assign(this.voiceList, data.Data.voiceList)
            Object.assign(this.voiceTypeList, data.Data.voiceTypeList)
            Object.assign(this.chnlGateList, data.Data.chnlGateList)
            Object.assign(this.chnlTypeList, data.Data.chnlTypeList)
            Object.assign(this.remoteOpenGateList, data.Data.remoteOpenGateList)
            Object.assign(this.rmtCtlOpenTypeList, data.Data.rmtCtlOpenTypeList)
            Object.assign(this.devList, data.Data.devList)
            Object.assign(this.delayMgrList, data.Data.delayMgrList)
            Object.assign(this.closeTypeList, data.Data.closeTypeList)
            Object.assign(this.closeTimeList, data.Data.closeTimeList)
            Object.assign(this.etcTypeList, data.Data.etcTypeList)
            Object.assign(this.etcUserTypeList, data.Data.etcUserTypeList)
            Object.assign(this.tmpCarInTypeList, data.Data.tmpCarInTypeList)
            Object.assign(this.tmpCarWaitDelayList, data.Data.tmpCarWaitDelayList)
            Object.assign(this.tmpCarTimeOutTypeList, data.Data.tmpCarTimeOutTypeList)
            Object.assign(this.monCarInTypeList, data.Data.monCarInTypeList)
            Object.assign(this.monCarWaitDelayList, data.Data.monCarWaitDelayList)
            Object.assign(this.monCarTimeOutTypeList, data.Data.monCarTimeOutTypeList)
            Object.assign(this.shra2019GJKComList, data.Data.shra2019GJKComList)
            Object.assign(this.monHSTypeList, data.Data.monHSTypeList)
            Object.assign(this.tempHSTypeList, data.Data.tempHSTypeList)
            Object.assign(this.othCardInTypeList, data.Data.othCardInTypeList)
            this.defaultValue.othCardInTypeList_defaultValue = data.Data.othCardInTypeList_defaultValue
            this.defaultValue.tempHSTypeList_defaultValue = data.Data.tempHSTypeList_defaultValue
            this.defaultValue.monHSTypeList_defaultValue = data.Data.monHSTypeList_defaultValue
            this.defaultValue.chnlTypeList_defaultValue = data.Data.chnlTypeList_defaultValue
            this.defaultValue.crtIoList_defaultValue = data.Data.crtIoList_defaultValue
            this.defaultValue.camList_defaultValue = data.Data.camList_defaultValue
            this.defaultValue.ledMainList_defaultValue = data.Data.ledMainList_defaultValue
            this.defaultValue.ledMainTypeList_defaultValue = data.Data.ledMainTypeList_defaultValue
            this.defaultValue.ledSubList_defaultValue = data.Data.ledSubList_defaultValue
            this.defaultValue.ledSubTypeList_defaultValue = data.Data.ledSubTypeList_defaultValue
            this.defaultValue.ledFullList_defaultValue = data.Data.ledFullList_defaultValue
            this.defaultValue.ledFullTypeList_defaultValue = data.Data.ledFullTypeList_defaultValue
            this.defaultValue.voiceList_defaultValue = data.Data.voiceList_defaultValue
            this.defaultValue.voiceTypeList_defaultValue = data.Data.voiceTypeList_defaultValue
            this.defaultValue.chnlGateList_defaultValue = data.Data.chnlGateList_defaultValue
            this.defaultValue.remoteOpenGateList_defaultValue = data.Data.remoteOpenGateList_defaultValue
            this.defaultValue.rmtCtlOpenTypeList_defaultValue = data.Data.rmtCtlOpenTypeList_defaultValue
            this.defaultValue.devList_defaultValue = data.Data.devList_defaultValue
            this.defaultValue.delayMgrList_defaultValue = data.Data.delayMgrList_defaultValue
            this.defaultValue.closeTypeList_defaultValue = data.Data.closeTypeList_defaultValue
            this.defaultValue.closeTimeList_defaultValue = data.Data.closeTimeList_defaultValue
            this.defaultValue.etcTypeList_defaultValue = data.Data.etcTypeList_defaultValue
            this.defaultValue.etcUserTypeList_defaultValue = data.Data.etcUserTypeList_defaultValue
            this.defaultValue.shra2019GJKComList_defaultValue = data.Data.shra2019GJKComList_defaultValue
            this.defaultValue.tmpCarInTypeList_defaultValue = data.Data.tmpCarInTypeList_defaultValue
            this.defaultValue.tmpCarWaitDelayList_defaultValue = data.Data.tmpCarWaitDelayList_defaultValue
            this.defaultValue.tmpCarTimeOutTypeList_defaultValue = data.Data.tmpCarTimeOutTypeList_defaultValue
            this.defaultValue.monCarInTypeList_defaultValue = data.Data.monCarInTypeList_defaultValue
            this.defaultValue.monCarWaitDelayList_defaultValue = data.Data.monCarWaitDelayList_defaultValue
            this.defaultValue.monCarTimeOutTypeList_defaultValue = data.Data.monCarTimeOutTypeList_defaultValue
          }
        }
      }
    })
    // 初始化端口
    this.comPortList.push({ text: '无', value: '无' })
    for (var i = 1; i <= 30; i++) {
      this.comPortList.push({ text: 'COM' + i, value: 'COM' + i })
    }
    for (var j = 0; j <= 9; j++) {
      this.volList.push({ text: j, value: j })
    }
    for (let i = 0; i <= 24; i++) {
      let hour = i < 10 ? '0' + i : i
      this.time.push({ label: hour + ':00', value: hour + ':00' })
      if (i <= 23) {
        this.time.push({ label: hour + ':30', value: hour + ':30' })
      }
    }
    for (let i = 0; i <= 23; i++) {
      let hour = i < 10 ? '0' + i : i
      for (let j = 0; j <= 55; j += 5) {
        let minute = j < 10 ? '0' + j : j
        this.timeToComboBoxList.push({ label: hour + ':' + minute, value: hour + ':' + minute })
      }
    }
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* #channelMain .el-input__inner {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
} */
/* .myChnlEditOrDetail .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 13px;
} */
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myChnlEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myChnlEditOrDetail .el-dialog__title {
  color: white;
}
.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}
.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}
.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}
/* dialog弹出框样式 */
#channelMain .channelDialog .el-dialog {
  min-width: 910px;
}
#channelMain .screenDialog .el-dialog {
  min-width: 800px;
}
#channelMain .voiceDialog .el-dialog {
  min-width: 410px;
}
#channelMain .warning-row {
  color: chocolate;
}
</style>

<style scoped>
fieldset {
  padding-bottom: 0px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}

.el-form-item {
  margin-bottom: 0px;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.dialog-video-wrapper .el-dialog__body {
  padding: 5px;
}
.myel-input__inner {
  height: 20px;
  line-height: 20px;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 10px;
  line-height: inherit;
  color: #333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
fieldset {
  margin: 0 2px;
  border: 0px solid silver;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/park/channelMain.vue